import { render, staticRenderFns } from "./InSegment.vue?vue&type=template&id=0051214c&scoped=true&"
import script from "./InSegment.vue?vue&type=script&lang=js&"
export * from "./InSegment.vue?vue&type=script&lang=js&"
import style0 from "./InSegment.vue?vue&type=style&index=0&id=0051214c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0051214c",
  null
  
)

export default component.exports